import * as React from 'react';

import LanguagesTable from './LanguagesTable';

export default class Languages extends React.Component {
  
  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <LanguagesTable />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Languages/index.tsx